import { render, staticRenderFns } from "./DrawerFooter.vue?vue&type=template&id=03780842&"
import script from "./DrawerFooter.vue?vue&type=script&lang=js&"
export * from "./DrawerFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports